if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
      document.querySelectorAll(".product-page__size-table a").forEach(sizeTableLink => {
        sizeTableLink.removeEventListener('click', this.handleSizeTableLinkClick);
        sizeTableLink.addEventListener('click', this.handleSizeTableLinkClick);
      });
      
      document.querySelectorAll(".product-page__size-table--adviser").forEach(sizeAdvisorLink => {
        sizeAdvisorLink.removeEventListener('click', this.handleSizeAdvisorClick);
        sizeAdvisorLink.addEventListener('click', this.handleSizeAdvisorClick);
      });
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();

        if (data.status) this.setErrorMsgState(data.description);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          // Update cart drawer contents.
          if (this.cartDrawer) {
            await this.cartDrawer.renderContents(
              data,
              !quickAddDrawer && theme.settings.afterAtc === 'drawer',
              () => {
                // Callback function that runs after the drawer is fully opened
              }
            );
          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) await cartItems.refreshCart();
          }
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.classList.remove('is-loading');
        this.submitBtn.classList.remove('is-success');
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }

    handleSizeTableLinkClick (ev) {
      ev.preventDefault();
      const href = ev.target.getAttribute('href');

      const modal = document.createElement("modal-dialog");
      modal.className = "modal size-modal invisible fixed top-0 left-0 w-full h-full flex items-center justify-center";
      modal.id = "size-table";
      modal.setAttribute('open', '');

      modal.innerHTML = `
        <div class="modal__window relative bg-theme-bg text-theme-text text-start overflow-hidden has-motion" role="dialog" aria-modal="true" tabindex="-1">
          <button type="button" class="modal__close-btn absolute js-close-modal">
            <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon">
              <path d="M5 19 19 5M5 5l14 14"></path>
            </svg>
            <span class="visually-hidden">Schließen</span>
          </button>
          <div class="modal__content flex-auto h-full rte">
            <div class="loading-spinner" role="status"></div>
          </div>
        </div>
      `;

      document.body.appendChild(modal);

      if (href.includes('.pdf')) {
        // PDF embedded as iframe
        modal.querySelector('.modal__content').innerHTML = `
          <iframe class="size-modal-iframe" src="${href}"></frame>
        `
      } else {
        // insert page content into the modal
        fetch(href)
        .then(response => response.text())
        .then(html => {
          const tempElement = document.createElement('div');
          tempElement.innerHTML = html;
          const pageContent = tempElement.querySelector('.page__content');

          if (pageContent) {
            modal.querySelector('.modal__content').innerHTML = pageContent.innerHTML;
          } else {
            modal.querySelector('.modal__content').innerHTML = html;
          }
        })
        .catch(error => {
          console.error('Error fetching page content:', error);
          modal.querySelector('.modal__content').innerHTML = '404 - Not found';
        });
      }
    }

    handleSizeAdvisorClick (ev) {
      ev.preventDefault();
      const url = ev.target.getAttribute('data-size-advisor-url');

      // Disable scrolling on the main page
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      const modal = document.createElement("modal-dialog");
      modal.className = "modal size-advisor-modal invisible fixed top-0 left-0 w-full h-full flex items-center justify-center";
      modal.id = "size-advisor";
      modal.setAttribute('open', '');

      modal.innerHTML = `
        <div class="modal__window relative bg-theme-bg text-theme-text text-start overflow-hidden has-motion" role="dialog" aria-modal="true" tabindex="-1">
          <button type="button" class="modal__close-btn absolute js-close-modal">
            <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon">
              <path d="M5 19 19 5M5 5l14 14"></path>
            </svg>
            <span class="visually-hidden">Schließen</span>
          </button>
          <div class="modal__content flex-auto h-full rte relative">
            <!-- Loading State -->
            <div class="size-advisor-loading absolute inset-0 bg-theme-bg z-10">
              <div class="loading-spinner" role="status"></div>
            </div>
            <!-- Iframe -->
            <iframe class="size-advisor-iframe" src="${url}" frameborder="0" allowfullscreen onload="this.parentElement.querySelector('.size-advisor-loading').style.display='none';"></iframe>
          </div>
        </div>
      `;

      // Event listener for closing the modal
      const closeModal = () => {
        // Scroll on the main page again
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        
        if (modal.parentNode) {
          modal.parentNode.removeChild(modal);
        }
      };

      // Close Button Event
      modal.addEventListener('click', function(e) {
        if (e.target.classList.contains('js-close-modal')) {
          closeModal();
        }
      });

      // ESC to close
      const handleEsc = function(e) {
        if (e.key === 'Escape') {
          closeModal();
          document.removeEventListener('keydown', handleEsc);
        }
      };
      document.addEventListener('keydown', handleEsc);

      document.body.appendChild(modal);
    }
  }

  customElements.define('product-form', ProductForm);
}
